
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M21.2 14.1l-7.1-7-7-7.1L0 7.1l7.1 7 7 7.1 3.8 3.8 7.1-7.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M35.9 21.2l7-7.1 7.1-7L42.9 0l-7 7.1-7.1 7-3.8 3.8 7.1 7.1zM46.5 39.5v-.1l-7-7-7.4-7.4-7.1 7.1 7.4 7.4 7 7h.1l3.4 3.5 7.1-7.1-3.5-3.4zM10.5 32.4l-7 7v.1L0 42.9 7.1 50l3.4-3.5h.1l7-7 7.4-7.4-7.1-7.1z"}})])
          )
        }
      }
    